<template>
    <div class="row">
        <scenario-selection-confirmation-popup
            ref="confirmationPopup"
            v-bind:scenarios="selectedScenarios"
            @confirm="navigateToSelectedScenarioTemplatesPage"
        >
        </scenario-selection-confirmation-popup>
        
        <div class="col-3 form-group">
            <division-dropdown
                v-if="divisionList"

                :division-list="divisionList"
                :value="divisionId"
                
                @input="selectDivisionId($event)"
            />
        </div>
        
        <div class="col-12 form-group">
            <div class="box">
                <div class="box-body">
                    <scenario-list v-bind:scenarios="scenarios">
                        <template v-slot:="{scenario}">
                            <scenario-list-item
                                :key="scenario.id"
                                v-bind:scenario="scenario"
                                @scenario-selection-changed="onScenarioSelectionChanged(scenario.id, $event)"
                            >
                            </scenario-list-item>
                        </template>
                    </scenario-list>

                    <div class="row" v-if="canWrite">
                        <div class="col-12 form-group text-right">
                            <button
                                v-if="hasSelectedScenarios"

                                class="btn btn-lg btn-primary"
                                @click="showConfirmationPopup"
                            >
                                {{resource('DmVisualizer_Index_SelectionConfirmationPopup_Title')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
    import sortScenariosMixin from '../Mixins/sort-scenarios-mixin';
    import resourceMixin from '../../../Util/Mixins/resources';
    
    import dmVisualizerApi from '../../../Api/dm-visualizer';
    import divisionApi from '@core/Api/divisions';
    import growler from "../../../Util/growler";
    import loader from "@core/Util/loader";
    
    import DivisionDropdown from '@core/Components/Util/DivisionDropdown';
    
    import ScenarioList from "./ScenarioList.vue";
    import ScenarioListItem from "./Index/ScenarioListItem.vue";
    import ScenarioSelectionConfirmationPopup from "./Index/ScenarioSelectionConfirmationPopup.vue";
    import {RouteNames} from "../constants";
    
    export default {
        name: "index",
        
        mixins: [sortScenariosMixin, resourceMixin],
        
        components: {
            DivisionDropdown,

            ScenarioList,
            ScenarioListItem,
            ScenarioSelectionConfirmationPopup
        },
        
        props: {
            divisionId: {
                type: String,
                required: false,
                default: undefined
            }
        },

        data: () => ({
            scenarios: [],
            selectedScenarioIds: [],
            divisionList: undefined,
            canWrite: false
        }),

        computed: {
            hasSelectedScenarios(){
                return !!this.selectedScenarioIds.length;
            },
            
            selectedScenarios(){
                const vm = this;

                const selectedScenarios = vm.scenarios.filter(s => vm.selectedScenarioIds.indexOf(s.id) !== -1);
                return this.sortScenarios(selectedScenarios);
            }
        },
        
        created() {
            const vm = this;
          
            dmVisualizerApi.setDivisionId(vm.divisionId);

            vm.loadScenarios();

            dmVisualizerApi.validateWritePermission().then(
                canWrite => vm.canWrite = canWrite
            );

            divisionApi.getDivisionsList().then(
                divisionList => vm.divisionList = divisionList,
                err => growler.bootstrapDanger(err)
            );
        },
        
        methods: {
            async selectDivisionId(divisionId) {
                if(this.divisionId === divisionId) {
                    return;
                }

                await this.$router.push({
                    name: this.$route.name,
                    query: { divisionId: divisionId }
                });

                dmVisualizerApi.setDivisionId(this.divisionId);

                //Wait for route based prop to update
                this.$nextTick();
                await this.loadScenarios();
            },
            
            async loadScenarios() {
                try {
                    loader.show();
                    
                    //Certain child components are a bit janky - force full rerender by clearing our scenarios list for a single render cycle
                    this.scenarios = [];
                    await this.$nextTick();
                    
                    this.scenarios = await dmVisualizerApi.listScenarios();
                } catch (e) {
                    growler.bootstrapDanger(e);
                } finally {
                    loader.hide();
                }
            },
            
            onScenarioSelectionChanged(scenarioId, isSelected){
                //Select a scenario when not yet present in our selectedScenarios
                //Deselect a scenario when present in our selectedScenarios
                const vm = this;

                const currentIndex = vm.selectedScenarioIds.indexOf(scenarioId);

                if(currentIndex === -1 && isSelected){
                    vm.selectedScenarioIds.push(scenarioId);
                }
                else if (currentIndex !== -1 && !isSelected){
                    vm.selectedScenarioIds.splice(currentIndex, 1);
                }
            },

            showConfirmationPopup() {
                this.$refs.confirmationPopup.show();
            },

            navigateToSelectedScenarioTemplatesPage(){
                this.$router.push({
                    name: RouteNames.TEMPLATES,
                    query: {
                        divisionId: this.divisionId,
                        scenarioIds: this.selectedScenarioIds
                    }
                });
            }
        }
    };
</script>
